/**
 * Web stub for react-native-responsive-screen
 * Provides responsive sizing functions for web
 */

const widthPercentageToDP = (widthPercent: number | string): number => {
  const screenWidth = typeof (global as any).window !== 'undefined' ? (global as any).window.innerWidth : 375;
  const elemWidth = typeof widthPercent === 'number' ? widthPercent : parseFloat(widthPercent as string);
  return (screenWidth * elemWidth) / 100;
};

const heightPercentageToDP = (heightPercent: number | string): number => {
  const screenHeight = typeof (global as any).window !== 'undefined' ? (global as any).window.innerHeight : 667;
  const elemHeight = typeof heightPercent === 'number' ? heightPercent : parseFloat(heightPercent as string);
  return (screenHeight * elemHeight) / 100;
};

const listenOrientationChange = (cb: () => void) => {
  if (typeof (global as any).window !== 'undefined') {
    (global as any).window.addEventListener('orientationchange', cb);
    return () => (global as any).window.removeEventListener('orientationchange', cb);
  }
  return () => {};
};

const removeOrientationListener = (cb: () => void) => {
  if (typeof (global as any).window !== 'undefined') {
    (global as any).window.removeEventListener('orientationchange', cb);
  }
};

export {
  widthPercentageToDP,
  heightPercentageToDP,
  listenOrientationChange,
  removeOrientationListener,
};

export default {
  widthPercentageToDP,
  heightPercentageToDP,
  listenOrientationChange,
  removeOrientationListener,
};
